module.exports = __webpack_public_path__ + "img/story-3.fa478925.jpg";